<section>
  <div class="container-fluid">
    <form>
      <div class="row m-4">
        <div class="form-group col-md-1">
          <label class="control-label fw-bold">Please&nbsp;select:</label>
        </div>

        <!--<div class="form-group col-md-3">-->
        <!--<label for="templateProductLineSelection" class="control-label">Product Line:</label>-->
        <!--<select id="templateProductLineSelection" name="templateProductLineSelection" class="form-control"-->
        <!--[(ngModel)]="templateProductLineSel"-->
        <!--(change)="resetProgramSel()">-->
        <!--<option *ngFor="let templateProductLine of templateProductLines"-->
        <!--[ngValue]="templateProductLine">{{templateProductLine.code}}-->
        <!--</option>-->
        <!--</select>-->
        <!--</div>-->

        <div class="form-group col-md-4">
          <label for="localeSelection" class="control-label fw-bold">Locale:</label>
          <select id="localeSelection" name="localeSelection" class="form-control"
                  [ngModel]="localeSel"
                  (ngModelChange)="setLocaleSel($event)">
            <option *ngFor="let locale of locales"
                    [ngValue]="locale">{{locale.displayLabels.en_US}}
            </option>
          </select>
        </div>

        <div class="form-group col-md-4">
          <label for="programSelection" class="control-label fw-bold">Operator - Program - Product:</label>
          <select id="programSelection" name="programSelection" class="form-control"
                  [ngModel]="productSel"
                  (ngModelChange)="setProgramSel($event)">
            <option *ngFor="let product of products"
                    [ngValue]="product">{{getOperatorProgramProductDisplayLabel(product)}}
            </option>
          </select>
        </div>

        <!--<div class="form-group col-md-3">-->
        <!--<label for="templateSelection" class="control-label">Template:</label>-->
        <!--<select id="templateSelection" name="templateSelection" class="form-control" [(ngModel)]="templateSel">-->
        <!--<option *ngFor="let template of templates | templatesByComponentType: templateProductLineSel"-->
        <!--[ngValue]="template">{{template.displayLabel}}-->
        <!--</option>-->
        <!--</select>-->
        <!--</div>-->

        <div class="col" style="float: right" *ngIf="checkSelection()">
          <br>
          <button id="downloadBulkEditExcelVBAFile" type="button"
                  class="btn btn-primary"
                  style="float: right; margin-top: 6px;" title="Download"
                  [disabled]="exportingExcelFile"
                  (click)="downloadBulkEditExcelXLXS()">
            <i [class]="'fa fa-lg ' + (exportingExcelFile?'fa-spinner fa-spin':'fa-download')"></i>
          </button>
        </div>
      </div>

    </form>
  </div>
</section>
